import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import _ from 'lodash';

import trainTime from '../../../lib/TrainTime';
import MomentPropTypes from "../../../helpers/MomentPropTypes";

import CombinedTimeSelector from './CombinedTimeSelector';
import HourSelector from './HourSelector';
import MinuteSelector from './MinuteSelector';

function TimeSelector ({ combined, disabled, datetime, min, max, onChange, className, minuteStep, ariaLabel }) {

    let minHour = 0;
    let minMinute = 0;
    let maxHour = 23;
    let maxMinute = 59;

    if (min && datetime.isSame(min, 'day')) {
        minHour = min.hour();
        if (datetime.isSame(min, 'hour')) {
            minMinute = min.minute();
        }
    }

    if (max && datetime.isSame(max, 'day')) {
        maxHour = max.hour();
        if (datetime.isSame(max, 'hour')) {
            maxMinute = max.minute();
        }
    }

    const handleTimeChangeCombined = newDatetime => {
        const updated = newDatetime.clone().set({
            hour: newDatetime.hour(),
            minute: newDatetime.minute()
        });
        onChange(updated);
    };

    const handleTimeChangeFor = (field) => (value) => {
        const updated = datetime.clone().set({ [field]: value });
        onChange(updated);
    };

    return (
        <div className={ className }>
            {combined ? (
                <CombinedTimeSelector
                    datetime={ datetime }
                    minuteStep={ minuteStep }
                    onChange={ handleTimeChangeCombined }
                    disabled={ disabled }
                    min={ min }
                    max={ max }
                    ariaLabel={ariaLabel}
                />
            ) : (
                <Fragment>
                    <HourSelector
                        hour={ datetime.hour() }
                        onChange={ handleTimeChangeFor('hour') }
                        disabled={ disabled }
                        min={ minHour }
                        max={ maxHour }
                    />
                    <MinuteSelector
                        minute={ datetime.minute() }
                        minuteStep={ minuteStep }
                        onChange={ handleTimeChangeFor('minute') }
                        disabled={ disabled }
                        min={ minMinute }
                        max={ maxMinute }
                    />
                </Fragment>
            )}
        </div>
    );
}

TimeSelector.propTypes = {
    combined: PropTypes.bool,
    datetime: MomentPropTypes.isMoment,
    onChange: PropTypes.func,
    min: MomentPropTypes.isMoment,
    max: MomentPropTypes.isMoment,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    minuteStep: PropTypes.number,
    ariaLabel: PropTypes.string,
};

TimeSelector.defaultProps = {
    combined: false,
    datetime: trainTime(),
    onChange: _.noop,
    disabled: false,
    min: null,
    max: null,
    className: '',
    minuteStep: 15
};

export default TimeSelector;
